export default class WebShareHelper {
    private constructor(private data: ShareData) {}

    public static init(data: ShareData) {
        if (WebShareHelper.canShare(data)) {
            return new this(data);
        }
        throw new Error("Web sharing is not available");
    }

    public openDialog() {
        return this.share();
    }

    public static isAvailable() {
        // Need to supply any kind of data to for canShare parameters, otherwise it will return with false
        // regardless of whether the feature is available or not.
        return WebShareHelper.canShare({
            title: "Example",
            text: "example",
            url: "https://example.com",
        });
    }

    private share() {
        // `share` may be provided by the native app as a fallback for browser `navigator.share`
        if (navigator.share) {
            navigator.share(this.data);
        } else if (window.NativeApp?.share) {
            // javascript bridge function must always be accessed from the injected object
            window.NativeApp?.share(this.data.text, this.data.title);
        }
    }

    private static canShare(data: ShareData) {
        return (
            (!!navigator.canShare && navigator.canShare(data)) ||
            !!window.NativeApp?.share
        );
    }
}
